<template>
  <div class="fan-list panel-data" :class="[`bg-${bgType}`, { 'has-user-info': !!userInfo }]">
    <div class="title-box panel-head">
      <div class="item title1">
        <div class="label-box">
          <span class="label-shadow">排名</span>
          <span class="label-text">排名</span>
        </div>
      </div>
      <div class="item title2">
        <div class="inner">
          <div class="label-box">
            <span class="label-shadow">粉丝昵称</span>
            <span class="label-text">粉丝昵称</span>
          </div>
        </div>
      </div>
      <div class="item title3">
        <div class="label-box">
          <span class="label-shadow">贡献值</span>
          <span class="label-text">贡献值</span>
        </div>
      </div>
    </div>
    <div class="fan-box">
      <div class="fan-center-warp" v-if="items && items.length > 0">
        <div class="list-items panel-row" v-for="(item, index) in items" :key="index">
          <div class="first">
            <div class="label-box">
              <span class="label-shadow">{{ index + startIndex }}</span>
              <span class="label-text">{{ index + startIndex }}</span>
            </div>
          </div>
          <div class="nanu">
            <div
              class="avatar"
              :style="{ 'background-image': `url(${item?.avatarUrl || defaultAvatar})` }"
            ></div>
            <div class="name">{{ item.nickName || '-' }}</div>
          </div>
          <div class="hot">{{ formatPopularity(item?.popularity) }}</div>
        </div>
      </div>
      <UiEmpty v-else class="fan-empty" tip="暂无更多粉丝~" />
    </div>

    <!-- 底部当前用户排名条 (可选, absolute 吸底到 .fan-list) -->
    <div v-if="userInfo" class="fan-user-box">
      <div class="fan-user">
        <div class="first">
          <div class="label-box rank-none" v-if="userInfo.rank === 0">
            <span class="label-shadow">未上榜</span>
            <span class="label-text">未上榜</span>
          </div>
          <div class="label-box" v-else>
            <span class="label-shadow">{{ userInfo.rank }}</span>
            <span class="label-text">{{ userInfo.rank }}</span>
          </div>
        </div>
        <div class="nanu">
          <div class="avatar" :style="{ 'background-image': `url(${userImgUrl})` }"></div>
          <div class="name">
            <div class="label-box">
              <span class="label-shadow">{{ userInfo.nickName }}</span>
              <span class="label-text">{{ userInfo.nickName }}</span>
            </div>
          </div>
        </div>
        <div class="hot">
          <div class="label-box">
            <span class="label-shadow">{{ formatPopularity(userInfo.popularity) }}</span>
            <span class="label-text">{{ formatPopularity(userInfo.popularity) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import UiEmpty from '@/components/ui-empty'

defineProps({
  items: { type: Array, default: () => [] },
  defaultAvatar: { type: String, required: true },
  startIndex: { type: Number, default: 4 },   // 起始排名(前 3 由 FanTopThree 展示, 列表从 4 起)
  userInfo: { type: Object, default: null },  // 当前用户排名数据 (可选, 传了则底部显示)
  userImgUrl: { type: String, default: '' },  // 当前用户头像
  bgType: { type: String, default: 'gradient' }  // 'gradient'(粉丝排行) | 'solid'(人气/个人排行)
})

function formatPopularity(p) {
  if (!p) return 0
  if (p < 10000) return p
  if (p < 99999999) return (p / 10000).toFixed(2) + '万'
  return '9999万+'
}
</script>

<style lang="scss" scoped>
@import "./panels";

.fan-list {
  // panel-data 提供: 灰白渐变 + 白描边 + 外投影 + display flex column
  overflow: hidden;   // clip fan-user-box 顶部负 margin 溢出

  // bg-solid 变体: 底色改成纯色 #E0E0E0 (人气/个人排行使用), 默认 bg-gradient 保持 panel-data 灰白渐变
  &.bg-solid.panel-data::before { background: #E0E0E0; }

  .title-box {
    // panel-head 提供: 高 57 + 字号 24 + multiply 粉底 + label 白/暗红 + item 通用 label-box padding + span 省略
    justify-content: space-between;
    .item {
      display: flex;

      &.title1 {
        @include r(margin-left, 55);
      }
      &.title2 {
        width: 25%;
        justify-content: flex-start;
        @include r(margin-left, 100);
        .inner {
          position: relative;
        }
      }
      &.title3 {
        text-align: center;
        @include r(margin-right, 63);
      }
    }
  }

  .fan-box {
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;

    .fan-empty {
      :deep(.empty-box) { width: get_vh(360); }
      :deep(.icon) {
        width: get_vh(240);
        height: get_vh(180);
      }
    }
  }

  .fan-center-warp {
    .list-items {
      // panel-row 提供: 高 65 + 字号 20 + multiply 奇偶背景 + 主字色
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .first {
        box-sizing: border-box;
        @include r(width, 63);
        @include r(font-size, 40);
        font-weight: bold;
        font-family: NumFont;
        display: flex;
        justify-content: center;
        align-items: center;
        @include r(margin-left, 55);
        .label-box {
          .label-shadow { color: #fff; }
          .label-text { color: #333333; }
        }
      }

      .nanu {
        box-sizing: border-box;
        width: 25%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        @include r(margin-left, 40);
        .avatar {
          @include r(width, 48);
          @include r(height, 48);
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          border-style: solid;
          border-color: #DDDDDD;
          @include r(border-width, 2);
          @include r(margin-right, 5);
        }
        .name {
          text-align: left;
          font-weight: 500;
        }
      }

      .hot {
        box-sizing: border-box;
        @include r(width, 86);
        text-align: center;
        @include r(margin-right, 63);
      }

    }
  }

  // 有 fan-user-box(斜边覆盖 fan-box 底部)时, 给最后一行加 margin-bottom, 避免最后一条被斜边遮挡
  &.has-user-info .list-items:last-of-type {
    @include r(margin-bottom, 16);
  }

  // 底部当前用户排名条 (参与 flex 布局吸底, 显示当前用户的排名/昵称/贡献值)
  // negative margin-top: 视觉 91 高保留完整背景, flex 布局只占 65, 顶部斜边 26 覆盖 fan-box 底部
  .fan-user-box {
    z-index: 1;
    flex-shrink: 0;
    @include r(height, 91);
    @include r(margin-top, -34);
    background: url(https://website.xdcdn.net/poster/58881/26match/common/QUWHE9e9.png) center/100% 100% no-repeat;

    .fan-user {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      @include r(height, 65);
      @include r(margin-top, 27);
      @include r(font-size, 20);
      .label-box {
        .label-shadow { color: rgba(0, 0, 0, 0.4); }
        .label-text { color: #FFFFFF; }
      }

      .first, .nanu, .hot {
        .label-box .label-shadow {
          color: #6D0402;
        }
      }

      .first {
        box-sizing: border-box;
        @include r(width, 63);
        @include r(font-size, 40);
        font-weight: bold;
        font-family: NumFont;
        display: flex;
        justify-content: center;
        align-items: center;
        @include r(margin-left, 55);
        .rank-none {
          @include r(font-size, 26);
        }
      }

      .nanu {
        box-sizing: border-box;
        width: 25%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        @include r(margin-left, 40);
        .avatar {
          @include r(width, 48);
          @include r(height, 44.17);
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          @include r(border-radius, 4);
          border-style: solid;
          border-color: #DDDDDD;
          @include r(border-width, 2);
          @include r(margin-right, 14.51);
        }
        .name {
          text-align: left;
        }
      }

      .hot {
        box-sizing: border-box;
        @include r(width, 86);
        text-align: center;
        @include r(margin-right, 63);
      }
    }
  }
}
</style>
